<!-- 商务合作申请列表 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="head-title borderB">
          <div class="text">商务合作申请列表</div>
        </div>
        <div class="headSearch Fs14">
          <div class="form-data group">
            <span>状态：</span>
            <el-select
              size="mini"
              v-model="selectedOptions"
              @change="cascaderChange"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="agencyList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column prop="type" label="申请类型"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                v-if="scope.row.isread === 0"
                @confirm="confirmBut(scope.row)"
                title="审核后无法修改，确定通过吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >确认</el-link
                >
              </el-popconfirm>
              <span v-else>---</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ agencyList.total }}条记录，</span>
            <span class="pageNum">{{ agencyList.pageNum }}</span>
            <span>/{{ agencyList.pages }}页</span>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="agencyList.pageNum"
            :page-size="agencyList.pageSize"
            layout="prev, pager, next, jumper"
            :total="agencyList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiAgencyList, apiAgencyRead } from '@/api/management'

export default {
  name: '',
  props: [''],
  data() {
    return {
      agencyList: [], // 列表
      pages: {
        page: 1, // 页数
        size: 20
      },
      options: [
        { label: '待审核', value: 0 },
        { label: '已审核', value: 1 }
      ],
      selectedOptions: 0
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.AgencyList()
  },

  methods: {
    // 状态切换
    cascaderChange() {
      this.pages.page = 1
      console.log(this.selectedOptions)
      this.AgencyList()
    },
    // 列表-确认
    confirmBut(row) {
      console.log(row)
      apiAgencyRead({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.AgencyList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
      console.log(row)
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.AgencyList()
    },
    // 接口
    // 获取商务合作申请列表
    AgencyList() {
      apiAgencyList({
        page: this.pages.page,
        pageSize: this.pages.size,
        isRead: this.selectedOptions
      }).then(res => {
        if (res.status === 0) {
          this.agencyList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 172px);
    .el-table {
      height: calc(100vh - 224px);
      overflow: auto;
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
